import React from 'react'
import RenderValidateMessage from '../Validation/RenderValidateMessage'
import { Form } from 'react-bootstrap'


export default function TextInput(props) {
    const { errors, value, label, setValue, valueName, handleEnter, placeholder, required = false } = props;


    return (
        <Form.Group>
            <Form.Label>{required && <span className="text-danger">*</span>} {label}</Form.Label>
            <Form.Control type="text" value={value} onKeyDown={handleEnter} onChange={e => setValue({ [valueName]: e.target.value })} placeholder={placeholder} />
            <RenderValidateMessage errors={errors} field={valueName} />
        </Form.Group>
    )
}
